// it converts object's keys to snake_case
import { mapKeys, snakeCase } from 'lodash'

export default function convertKeysToSnakeCase<T extends Record<string, unknown>>(
  data: T
): Record<string, unknown> {
  return mapKeys(data, (value, key) => snakeCase(key))
}
